<template>
  <div>
    <v-row>
      <v-col>
        <v-form ref="form" lazy-validation v-model="valid">
          <v-row dense>
            <v-col cols="4" align="center">
              <v-text-field
                  label="Название подкатегории"
                  v-model="category.name"
                  required
                  :rules="nameRules"
              ></v-text-field>
            </v-col>
          </v-row>
           <v-row dense>
            <v-col cols="4" align="center">
              <v-text-field
                  label="Наименование меты(СЕО)"
                  v-model="category.title"
              ></v-text-field>
            </v-col>
          </v-row>
           <v-row dense>
            <v-col cols="4" align="center">
              <v-text-field
                  label="Описание меты(СЕО)"
                  v-model="category.description"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-select
                  v-model="category.categoryId"
                  :items="categories"
                  item-title="text"
                  item-value="value"
                  label="Категория"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" align="center">
              <v-checkbox
                  label="Удалена"
                  v-model="category.status"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" align="center">
              <v-checkbox
                  label="Показывать на сайте"
                  v-model="category.onSite"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" align="center">
              <v-checkbox
                  label="Быстрая ссылка"
                  v-model="category.quickLink"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="primary" @click="update" :disabled="isLoading">
                Сохранить
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {RepositoryFactory} from "@/repositories/RepositoryFactory";

const SubcategoryRepository = RepositoryFactory.get("subCategory");
const CategoryRepository = RepositoryFactory.get("category");

export default {
  data() {
    return {
      valid: true,
      isLoading: false,
      category: {
        id: null,
        name: "",
        altName: "",
        status: false,
        onSite: false,
        quickLink: false,
        categoryId: null,
        title: null,
        description: null
      },
      categories: [],
      nameRules: [
        (value) => {
          if (value) return true;
          return "Поле обязательно для заполнения.";
        },
      ],
    }
  },
  watch:{
    "$route.params.id"(){
      this.get();
    }
  },
  mounted() {
    this.getCategories();
    this.get();
  },
  methods: {
    async getCategories() {
      const result = await CategoryRepository.getCategoriesForSelect();
      if (result.data.status === "success") {
        this.categories = result.data.data;
      }
    },
    async get() {
      if (this.$route.params.id > 0) {
        this.isLoading = true;
        const result = await SubcategoryRepository.get(this.$route.params.id);
        if (result) {
          if (result.data.status === "success") {
            this.category = result.data.data;
          }
        }
        this.isLoading = false;
      }
      else{
        this.category = {
          id: null,
          name: "",
          altName: "",
          status: false,
          onSite: false,
          quickLink: false,
          categoryId: null,
          title: null,
          description: null
        }
      }
    },
    async create() {
      if (!this.valid) {
        return;
      }
      this.isLoading = true;
      const result = await SubcategoryRepository.create(this.category);
      if (result.data.status === "success") {
        this.$router.push({path: `/categories/edit/${result.data.data}`});
      }
      this.isLoading = false;
    },
    async update() {
      if (!this.valid) {
        return;
      }
      if (this.category.id > 0) {
        this.isLoading = true;

        const result = await SubcategoryRepository.update(this.category);

        this.isLoading = false;
      } else {
        await this.create(this.category);
      }
    },
  },
  computed: {},
};
</script>